<template>
  <b-modal
    id="do-you-want-to-add-another-child-info-modal"
    ref="do-you-want-to-add-another-child-info-modal"
    body-class="p-10"
    centered
    content-class="p-2"
    no-close-on-backdrop
    hide-header
    hide-footer
    @hidden="resetModal"
    @show="openModal"
  >
    <div>
      <h2 class="info-modal-title"> Would you like to add another {{ camperStudent('singular') }}?</h2>
    </div>


    <div
      class="info-modal-buttons w-100 d-flex">
      <b-button
        class="border border-primary"
        variant="outline-primary"
        @click="stopAdding"
      >
        No
      </b-button>
      <b-button
        variant="primary"
        class="ml-auto"
        @click="addNewChild"
      >
        Yes
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import { instanceSessionCamperNames } from '@core/mixins/instanceSessionCamperNames'
export default {
  components: {
    BModal,
    BButton,
  },
  mixins: [instanceSessionCamperNames],
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    resetModal() {},
    openModal() {},
    addNewChild() {
      this.$bvModal.hide('do-you-want-to-add-another-child-info-modal')
      this.$emit('add-new-child')
    },
    stopAdding() {
      this.$bvModal.hide('do-you-want-to-add-another-child-info-modal')
      this.$emit('stop-adding')
    },
  },
}
</script>

<style lang="scss" scoped>
  .info-modal-title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .info-modal-buttons {
    padding: 0 30px;
  }
</style>